import { IconPlayerPause } from '@tabler/icons-react';
import { useInvoiceSelection } from 'app/Private/Clients/Detail/UnhandledInvoicesTab/use-invoice-selection';
import { iconProps } from 'components/index';
import { tKeys, useTranslate } from 'locales/index';
import type { UnhandledInvoice } from 'modules/AtRisk/api/use-load-unhandled-client';
import type { ActionButtonDefinition } from '../action-button-definition';
import { openUnhandledInvoiceSelectionModal } from './open-unhandled-invoice-selection-modal';
import { usePauseWithNote } from './use-pause-with-note';

export function usePause(): (invoices: Array<UnhandledInvoice>) => ActionButtonDefinition {
  const t = useTranslate();
  const { selectedInvoiceIds } = useInvoiceSelection();
  const pauseWithNote = usePauseWithNote();

  return invoices => ({
    icon: <IconPlayerPause {...iconProps()} />,
    translationKey: tKeys.CLIENT.PAUSE,
    isEnabled: invoices.length > 0,
    recommended: null,
    eligibleInvoiceIds: invoices.map(invoice => invoice.id),
    onClick: () =>
      openUnhandledInvoiceSelectionModal({
        title: t(tKeys.DEBTOR.REACTION.SELECT_INVOICES),
        selectedInvoiceIds,
        invoices,
        actionType: 'pause',
        areAllInvoicesEligible: true,
        onNext: ({ invoiceIds }) => pauseWithNote(invoiceIds),
      }),
  });
}
